import { CATEGORIES } from "../data/articles.js";
import { useArticles } from "../lib/editApi.js";
import ArticleCard, { CategoryChips } from "../site/ArticleCard.jsx";

const BLURB = {
  planning:      "Timing, budgeting and island-picking — the decisions you make before anything is booked.",
  families:      "Beaches that suit small children, rentals with room to spread out, and resorts that earn their kids' club.",
  budget:        "Hawaiʻi without the resort markup: where to stay, when to go, and what is genuinely worth paying for.",
  experiences:   "Drives, hikes, beaches and the stays that put you closest to them.",
  culture:       "The history, language and living culture behind the places you will be staying in.",
  neighborhoods: "Where one town ends and the next begins, and which one fits the trip you want."
};

export default function CategoryPage({ category }) {
  const { articles, loaded } = useArticles();
  const label = CATEGORIES[category]?.label || category;
  const list = articles.filter(a => a.category === category);

  return (
    <div className="container-page py-16 md:py-20">
      <nav className="text-sm text-ink-muted">
        <a href="/edit/" className="hover:text-ocean-700">The Edit</a>
        <span className="px-2">/</span>
        <span className="text-ink">{label}</span>
      </nav>

      <header className="mt-6 max-w-2xl">
        <span className="eyebrow">{label}</span>
        <h1 className="section-title mt-3">{label} guides for Hawaiʻi stays</h1>
        <p className="prose-body mt-4 text-lg">{BLURB[category] || `${label} guides from Aloha Rates.`}</p>
      </header>

      <div className="mt-10"><CategoryChips active={category}/></div>

      {list.length > 0 ? (
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map(a => <ArticleCard key={a.slug} article={a}/>)}
        </div>
      ) : loaded ? (
        <div className="mt-16">
          <p className="prose-body">No {label.toLowerCase()} guides yet.</p>
          <a href="/edit/" className="btn-secondary mt-6 inline-flex">Browse everything in The Edit</a>
        </div>
      ) : null}
    </div>
  );
}
